// extracted by mini-css-extract-plugin
export default {"tooltip":"InfoTooltip_tooltip__jYA3h","tooltipTrigger":"InfoTooltip_tooltipTrigger__CljUL"};